import React, { useState } from 'react';
import { Send, CheckCircle2 } from 'lucide-react';
import { getUtmParams } from '../utils/utmTracking';
import { teamBuildingActivities } from '../data/corporateTeamBuilding';
const GROUP_SIZES = ['עד 20 משתתפים', '20-50 משתתפים', '50-100 משתתפים', 'מעל 100 משתתפים'];
interface FormState {
  fullName: string;
  company: string;
  phone: string;
  email: string;
  groupSize: string;
  preferredDate: string;
  activities: string[];
  notes: string;
}
const INITIAL_STATE: FormState = {
  fullName: '',
  company: '',
  phone: '',
  email: '',
  groupSize: '',
  preferredDate: '',
  activities: [],
  notes: ''
};
export function CorporateEventBuilderForm() {
  const [formData, setFormData] = useState<FormState>(INITIAL_STATE);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const toggleActivity = (title: string) => {
    setFormData(prev => ({
      ...prev,
      activities: prev.activities.includes(title) ? prev.activities.filter(a => a !== title) : [...prev.activities, title]
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.fullName.trim() || !formData.phone.trim()) return;
    setIsSubmitting(true);
    getUtmParams();
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'Lead', {
        content_name: 'Corporate Team Building',
        content_category: 'Groups and Organizations',
        currency: 'ILS'
      });
    }
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
      const lines = ['היי, אשמח לבנות יום גיבוש לארגון שלנו.', `שם: ${formData.fullName}`, formData.company && `חברה/ארגון: ${formData.company}`, `טלפון: ${formData.phone}`, formData.email && `אימייל: ${formData.email}`, formData.groupSize && `גודל קבוצה: ${formData.groupSize}`, formData.preferredDate && `תאריך מבוקש: ${formData.preferredDate}`, formData.activities.length > 0 && `פעילויות שמעניינות אותנו: ${formData.activities.join(', ')}`, formData.notes && `הערות: ${formData.notes}`].filter(Boolean);
      const text = encodeURIComponent(lines.join('\n'));
      window.open(`https://wa.me/972548800260?text=${text}`, '_blank');
    }, 900);
  };
  const inputClass = 'w-full bg-white border border-gray-200 rounded-xl py-3 px-4 text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-cyan-400 focus:border-transparent transition-colors';
  if (isSubmitted) {
    return <div className="text-center py-10" data-id="element-136" data-mp="1wee197y995df">
        <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-137" data-mp="1wdcnuwtro6sj">
          <CheckCircle2 className="w-8 h-8 text-emerald-600" data-id="element-138" data-mp="1m8wcafnblbuj" />
        </div>
        <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-139" data-mp="1r1fs7j9hcj2i">
          קיבלנו את הפרטים!
        </h3>
        <p className="text-gray-600 max-w-md mx-auto" data-id="element-140" data-mp="1cdcj41054r9h">
          נחזור אליכם בהקדם עם הצעה מותאמת ליום הגיבוש של הקבוצה שלכם.
        </p>
      </div>;
  }
  return <form onSubmit={handleSubmit} className="space-y-6" data-id="element-141" data-mp="2518cavqi411i">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-142" data-mp="251qgcejenjjz">
        <div data-id="element-143" data-mp="2a0bjalq1khc4">
          <label htmlFor="fullName" className="block text-sm font-semibold text-gray-700 mb-1.5" data-id="element-144" data-mp="29yqocuztewdq">
            שם מלא <span className="text-rose-500" data-id="element-145" data-mp="1v559rorqm0e1">*</span>
          </label>
          <input id="fullName" type="text" name="fullName" value={formData.fullName} onChange={handleChange} required placeholder="איך קוראים לך?" className={inputClass} data-id="element-146" data-mp="200awuqwvll3p" />
        </div>
        <div data-id="element-147" data-mp="14un05ks2e5ge">
          <label htmlFor="company" className="block text-sm font-semibold text-gray-700 mb-1.5" data-id="element-148" data-mp="14v66s5c9l7f4">
            שם החברה או הארגון
          </label>
          <input id="company" type="text" name="company" value={formData.company} onChange={handleChange} placeholder="שם החברה" className={inputClass} data-id="element-149" data-mp="v4trarjb44fu" />
        </div>
        <div data-id="element-150" data-mp="1itw6ztudrn7p">
          <label htmlFor="phone" className="block text-sm font-semibold text-gray-700 mb-1.5" data-id="element-151" data-mp="1itcx90evw54r">
            טלפון <span className="text-rose-500" data-id="element-152" data-mp="1dsowhn0us9xc">*</span>
          </label>
          <input id="phone" type="tel" name="phone" value={formData.phone} onChange={handleChange} required dir="ltr" placeholder="050-1234567" className={`${inputClass} text-right`} data-id="element-153" data-mp="18uf0ja7b15ao" />
        </div>
        <div data-id="element-154" data-mp="294y535axakyo">
          <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-1.5" data-id="element-155" data-mp="295gdf0av0pmy">
            אימייל
          </label>
          <input id="email" type="email" name="email" value={formData.email} onChange={handleChange} dir="ltr" placeholder="name@company.co.il" className={`${inputClass} text-right`} data-id="element-156" data-mp="2j0rtpn1x24wt" />
        </div>
        <div data-id="element-157" data-mp="2ws6f20jaqi71">
          <label htmlFor="groupSize" className="block text-sm font-semibold text-gray-700 mb-1.5" data-id="element-158" data-mp="2wrmsu7mm57n7">
            כמה אתם?
          </label>
          <select id="groupSize" name="groupSize" value={formData.groupSize} onChange={handleChange} className={inputClass} data-id="element-159" data-mp="36rnhm9394fys">
            <option value="" data-id="element-160" data-mp="1cckwenl8jk1o">בחרו גודל קבוצה</option>
            {GROUP_SIZES.map(size => <option key={size} value={size} data-id="element-161" data-mp="14bwqid1ks01v">
                {size}
              </option>)}
          </select>
        </div>
        <div data-id="element-162" data-mp="10cwat3ee9dj3">
          <label htmlFor="preferredDate" className="block text-sm font-semibold text-gray-700 mb-1.5" data-id="element-163" data-mp="10d64p22k84u2">
            תאריך מבוקש
          </label>
          <input id="preferredDate" type="date" name="preferredDate" value={formData.preferredDate} onChange={handleChange} className={inputClass} data-id="element-164" data-mp="19a6oswiljgrp" />
        </div>
      </div>

      <fieldset data-id="element-165" data-mp="1x1viohb2gdar">
        <legend className="block text-sm font-semibold text-gray-700 mb-3" data-id="element-166" data-mp="1x0ao4ror4ucw">
          מה מעניין אתכם ביום הזה?{' '}
          <span className="font-normal text-gray-500" data-id="element-167" data-mp="1s2sqhxg6q1k7">
            (אפשר לבחור כמה שרוצים, ואפשר גם להשאיר לנו להציע)
          </span>
        </legend>
        <div className="flex flex-wrap gap-2" data-id="element-168" data-mp="220oy4f9wyedk">
          {teamBuildingActivities.map(activity => {
          const active = formData.activities.includes(activity.title);
          return <button key={activity.id} type="button" onClick={() => toggleActivity(activity.title)} aria-pressed={active} className={`py-2 px-4 rounded-full text-sm font-semibold border transition-colors ${active ? 'bg-[#0A5F8F] text-white border-[#0A5F8F]' : 'bg-white text-gray-700 border-gray-200 hover:border-[#0A5F8F]'}`} data-id="element-169" data-mp="2pnk7lt0nn9ed">
                {activity.title}
              </button>;
        })}
        </div>
      </fieldset>

      <div data-id="element-170" data-mp="1syme0e4n5his">
        <label htmlFor="notes" className="block text-sm font-semibold text-gray-700 mb-1.5" data-id="element-171" data-mp="1sz4fbp65ulxk">
          ספרו לנו על הקבוצה ועל היום שאתם מדמיינים
        </label>
        <textarea id="notes" name="notes" value={formData.notes} onChange={handleChange} rows={4} placeholder="אופי הקבוצה, מטרות היום, אוכל, שעות, רעיונות מיוחדים..." className={`${inputClass} resize-none`} data-id="element-172" data-mp="1j0oo7m74vco2" />
      </div>

      <button type="submit" disabled={isSubmitting} className="w-full bg-[#0A5F8F] hover:bg-[#0D7AB8] disabled:opacity-70 text-white font-bold text-lg py-4 rounded-xl transition-colors shadow-lg flex items-center justify-center gap-2" data-id="element-173" data-mp="1zg7kcwi8828r">
        {isSubmitting ? <div className="w-6 h-6 border-2 border-white/30 border-t-white rounded-full animate-spin" data-id="element-174" data-mp="1kif8cebw1vzb" /> : <>
            <Send className="w-5 h-5" data-id="element-175" data-mp="1fosu4hq2tk1e" />
            בואו נבנה את היום שלנו
          </>}
      </button>
      <p className="text-center text-sm text-gray-500" data-id="element-176" data-mp="1bmxrn9wet0m1">
        נחזור אליכם עם הצעה מותאמת. אין התחייבות בשלב הזה.
      </p>
    </form>;
}